export const placeCollectionGuard = 'GET /places';

export const placeResourceGuard = 'GET /places/d+';

export const searchPlaceCollectionGuard = 'POST /places/search';

export const placesStreetCollectionGuard = 'GET /places/d+/streets';

export const placesMunicipalityCollectionGuard = 'GET /places/municipalities';
